import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ConstraintSpecDetailComponent } from '../../constraint-spec-detail/constraint-spec-detail.component'
import { Configuration } from '../Configuration'
import { ConfigurationUtils } from '../configuration-utils'

export interface IConfigurationDialogOptions {
  readonly config: Configuration
}

@Component({
  selector: 'app-configuration-dialog',
  templateUrl: './configuration-dialog.component.html',
  styleUrls: ['./configuration-dialog.component.scss'],
  imports: [ConstraintSpecDetailComponent],
})
export class ConfigurationDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly condition: Configuration
  public readonly original: Configuration
  dialogRef = inject<MatDialogRef<ConfigurationDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IConfigurationDialogOptions>(MAT_DIALOG_DATA)
    this.condition = new Configuration()
    this.original = data.config
    ConfigurationUtils.update(this.original, this.condition)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close()
  }

  public onSave($event: Event): void {
    this.close(this.condition)
  }

  public close(condition?: Configuration): void {
    this.dialogRef.close(condition)
  }
}
